module.exports = __webpack_public_path__ + "static/media/1.6428b896.jpg";